// eslint-disable-next-line import/no-cycle
import { DataSources } from '@leverege/ui-attributes';
import Relationships from "../dataSource/Relationships.js";
function add(rel) {
  Relationships.add(rel);
}
function getByPath(path) {
  return Relationships.getByPath(path);
}
function getAllByPath() {
  return Relationships.getAllByPath();
}
function getAll() {
  return Relationships.getAll();
}

/**
 * Returns an { delegate, objRef : { id, ref, type } } for the relationship and match
 */
function getObjectRefAndAction(rel, match) {
  const bRel = rel.createItem(match);
  const delegate = DataSources.getDelegate(bRel.objRef);
  return {
    objRef: bRel.objRef,
    delegate
  };
}
function getObjectRefHierarchy(relationship, match) {
  // let idKey
  let rel = relationship;
  const r = [];
  while (rel) {
    if (!rel.isItem) {
      r.push(rel.createItem(match).objRef);
    }
    rel = rel.parent;
  }
  return r;
}
function getResourceIdHierarchy(relationship, match, includeSysAndProject = true) {
  let idKey;
  let rel = relationship;
  const r = [];
  while (rel) {
    if (!rel.isItem) {
      idKey = `${rel.objectType}Id`;
      r.push(match.params[idKey]);
    }
    rel = rel.parent;
  }
  if (includeSysAndProject) {
    r.push(relationship.systemId);
    r.push(window.Molten.getConfig('api/projectId'));
  }
  return r;
}

/**
 * Returns the ancestor relationship whose path is ancestorPath
 */
function findAncestor(rel, ancestorPath) {
  let c = rel;
  while (c) {
    if (c.path === ancestorPath) {
      return c;
    }
    c = c.parentRelationship;
  }
  return null;
}
export default {
  getObjectRefAndAction,
  findAncestor,
  add,
  getByPath,
  getAll,
  getAllByPath,
  getObjectRefHierarchy,
  getResourceIdHierarchy
};